  var fullDomain = window.location.protocol + '//' + window.location.hostname;
  var makeDropdown = document.getElementById('make-dropdown');
  var yearDropdown = document.getElementById('year-dropdown');
  var modelDropdown = document.getElementById('model-dropdown');
  var ffSearch = document.getElementById('sbv-search-btn');
  const fwlocale = getShopifyLocale();
  var allData;
  var buynowclick;

  document.addEventListener('DOMContentLoaded', async function() {
    updateSearchBtnState();
    if (makeDropdown.options.length === 1) {
      await initializeDropdowns();
    }
  });

  function getShopifyLocale() {
    try {
      const el = document.getElementById("shopify-features");
      if (!el) return "en";

      const data = JSON.parse(el.textContent);
      return data.locale || "en";
    } catch (e) {
      console.error("Failed to read Shopify locale:", e);
      return "en";
    }
  }

  $('#sbv-closeIcon')
  .off('click.findway')
  .on('click.findway', function () {
    $('.Findway-filter').hide();
    dialogff.hide();
  });


  $('a.js-menu-link[href="/pages/shop-by-vehicle"], a.js-accordion-link[href="/pages/shop-by-vehicle"], a.js-menu-link[href="/fr/pages/shop-by-vehicle"], a.js-accordion-link[href="/fr/pages/shop-by-vehicle"]').on('click', function(e) {
    $('.js-slideout-close').trigger('click');
    e.preventDefault();    
    
    buynowclick = 'fwf';
    if (performance.getEntriesByType("navigation")[0] === "back_forward") {
      if (fwlocale === 'en') {
        makeDropdown.value = 'Select Make';
        yearDropdown.value = 'Select Year';
        modelDropdown.value = 'Select Model';
      } else if (fwlocale === 'fr') {
        makeDropdown.value = 'Sélectionnez la marque';
        yearDropdown.value = 'Sélectionnez l’année';
        modelDropdown.value = 'Sélectionnez le modèle';
      }
      updateDropdowns();
    }

    $('.Findway-filter').fadeToggle('fast', function () {
      if (!$('.Findway-filter').is(':visible')) {
        dialogff.hide();
      } else {
        if (e.pointerType !== 'mouse') {
          makeDropdown.focus();
        }
      }
    });
    // $('#sbv-closeIcon').on('click', function() {
    //   $('.Findway-filter').hide();
    //   dialogff.hide();
    // });
  });
 
  async function getAllMakes() {
    try {
      const response = await fetch('https://yvycs6obckonwmguydydwvgu5e0njtzk.lambda-url.ca-central-1.on.aws/', {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  }


async function getAllColls() {
  try {
    const response = await fetch('https://yvycs6obckonwmguydydwvgu5e0njtzk.lambda-url.ca-central-1.on.aws/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ colls: true }),
    });
 
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching data for Colls:`, error);
    return null;
  }
}


  async function initializeDropdowns() {
    const data = await getAllMakes();
    if (!data) {
      return;
    }
    data.sort((a, b) => a.VehicleMake.localeCompare(b.VehicleMake));
    data.forEach(function(make) {
      const option = document.createElement('option');
      option.value = make.VehicleMake;
      option.textContent = make.VehicleMake;
      makeDropdown.appendChild(option);
    });
  }

  
  function updateDropdowns() {
    if (makeDropdown.value === 'Select Make' || makeDropdown.value === 'Sélectionnez la marque' || makeDropdown.value === '') {
      yearDropdown.disabled = true;
      modelDropdown.disabled = true;
    } else {
      yearDropdown.disabled = false;
      modelDropdown.disabled = false;
    }
  }

async function getYears(make) {
  try {
    const response = await fetch('https://yvycs6obckonwmguydydwvgu5e0njtzk.lambda-url.ca-central-1.on.aws/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ make: make }),
    });
 
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const data = await response.json();
      return data;
    } else {
      const text = await response.text();
      console.warn('Response is not JSON:', text);
      return text;
    }
  } catch (error) {
    console.error(`Error fetching data for make ${make}:`, error);
    return null;
  }
}

async function fetchYearsData(make) {
  const result = await getYears(make);
  if (result && result.length > 0) {
    let allYears = [];
    result.forEach(item => {
      const years = JSON.parse(item.Year);
      allYears = allYears.concat(years);
    });
    const uniqueYears = [...new Set(allYears)];
    uniqueYears.sort((a, b) => b - a);
    return uniqueYears;
  } else {
    console.log('No data received from server.');
    return null;
  }
}

  makeDropdown.addEventListener('change', function() {
    updateSearchBtnState();
    updateDropdowns();
    var selectedMake = makeDropdown.value;
    
    while (yearDropdown.options.length > 1) {
      yearDropdown.remove(1);
    }
    while (modelDropdown.options.length > 1) {
      modelDropdown.remove(1);
    }
    if (selectedMake !== 'Select Make' && selectedMake !== 'Sélectionnez la marque') {
      fetchYearsData(selectedMake).then(data => {
        if (data) {
          data.forEach(function (year) {
            var option = document.createElement('option');
            option.value = year;
            option.textContent = year;
            yearDropdown.appendChild(option);
          });
        }
      });
    }
  });

async function getModels(make, year) {
  try {
    const response = await fetch('https://yvycs6obckonwmguydydwvgu5e0njtzk.lambda-url.ca-central-1.on.aws/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ make: make, year: year, lang: fwlocale }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const data = await response.json();
      return data;
    } else {
      const text = await response.text();
      console.warn('Response is not JSON:', text);
      return text;
    }

  } catch (error) {
    console.error(`Error fetching ${year} data for make ${make}:`, error);
    return null;
  }
}


async function fetchModelsData(make, year) {
  const result = await getModels(make, year);
  if (result) {
    const models = result.sort((a, b) => a.localeCompare(b));
    return models;
  } else {
    console.log('No data received from server.');
    return null;
  }
}

async function getData(make, year, model) {
  try {
    const response = await fetch('https://yvycs6obckonwmguydydwvgu5e0njtzk.lambda-url.ca-central-1.on.aws/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ make: make, year: year, model: model, lang: fwlocale }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const dataText = await response.text();
    const data = JSON.parse(dataText);
    return data;
  } catch (error) {
    console.error(`Error fetching data with getData():`, error);
    return null;
  }
}

async function fetchData(make, year, model) {
  const result = await getData(make, year, model);
  if (result) {
    return result;
  } else {
    console.log('No data received from server.');
    return null;
  }
}

yearDropdown.addEventListener('change', function() {
  updateSearchBtnState();
  if (yearDropdown.value !== 'Select Year' && yearDropdown.value !== 'Sélectionnez l’année') {
    selectedMake = makeDropdown.value;
    while (modelDropdown.options.length > 1) {
      modelDropdown.remove(1);
    }
    fetchModelsData(selectedMake, yearDropdown.value).then(data => {
      if (data) {
        console.log(data);
        data.forEach(function (model) {
          var option = document.createElement('option');
          option.value = model;
          option.textContent = model;
          modelDropdown.appendChild(option);
        });
      }
    });
  } else {
    while (modelDropdown.options.length > 1) {
      modelDropdown.remove(1);
    }
  }
});

// function createProductAnchor(vehicle) {
//   const a = document.createElement('a');
//   const text = document.createElement('p');
//   const img = new Image();
//   img.src = vehicle.PreviewImage;
//   img.className="w-64 h-auto max-h-64 rounded-xl";
//   img.alt = vehicle.CollectionName;
//   text.className = "max-w-64 text-lg mt-2.5 font-['Bebas_Neue']";
//   text.textContent = vehicle.CollectionName;
//   a.className = 'flex flex-col items-center text-center justify-between cursor-pointer';
//   a.setAttribute('tabindex', '0');
//   a.setAttribute('role', 'button');
//   a.setAttribute('aria-label', `View products in ${vehicle.CollectionName}`);
//   a.addEventListener('click', () => {
//     getOptsData(vehicle.CollectionID);
//   });
//   a.addEventListener('keydown', (e) => {
//     if (e.key === 'Enter' || e.keyCode === 13) {
//       e.preventDefault();
//       a.click();
//     }
//   });
//   a.appendChild(img);
//   a.append(text);
//   return a;
// }

function createProductAnchor(vehicle) {
  const a = document.createElement('a');
  const text = document.createElement('p');
  const img = new Image();
  img.src = vehicle.PreviewImage;
  img.className="max-w-full max-h-full object-contain rounded-xl";
  const imgContainer = document.createElement('div');
  imgContainer.className = 'w-64 h-64 flex items-center justify-center overflow-hidden';
  imgContainer.appendChild(img);
  text.className = "max-w-64 text-lg mt-2.5 font-['Bebas_Neue']";
  a.className = 'flex flex-col items-center text-center justify-between cursor-pointer';
  a.setAttribute('tabindex', '0');
  a.setAttribute('role', 'button');
  if (fwlocale === 'en') {
    img.alt = vehicle.CollectionName;
    text.textContent = vehicle.CollectionName;
    a.setAttribute('aria-label', `View products in ${vehicle.CollectionName}`);
  } else if (fwlocale === 'fr') {
    img.alt = vehicle.language?.fr?.CollectionName || vehicle.CollectionName;
    text.textContent = vehicle.language?.fr?.CollectionName || vehicle.CollectionName;
    a.setAttribute('aria-label', `Voir les produits de la gamme ${vehicle.language?.fr?.CollectionName || vehicle.CollectionName}`);
  }
  a.addEventListener('click', () => {
    getOptsData(vehicle.CollectionID);
  });
  a.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      a.click();
    }
  });
  a.appendChild(imgContainer);
  a.append(text);
  return a;
}

function addRelatedProductsLabel() {
  const hr = document.createElement('hr');
  const label = document.createElement('span');
  label.className = 'text-center text-lg font-semibold';
  hr.className = 'mt-0';
  if (fwlocale === 'en') {
    label.textContent = 'Related Products';
  } else if (fwlocale === 'fr') {
    label.textContent = 'Produits connexes';
  }
  $("#products-modal #products-modal-content").append(hr).append(label);
}

function updateSearchBtnState() {
  const make  = makeDropdown.value;
  const year  = yearDropdown.value;
  const model = modelDropdown.value;

  if (make !== '' && make !== 'Select Make' && make !== 'Sélectionnez la marque'
   && year !== '' && year !== 'Select Year' && year !== 'Sélectionnez l’année'
   && model !== '' && model !== 'Select Model' && model !== 'Sélectionnez le modèle') {
    ffSearch.disabled = false;
  } else {
    ffSearch.disabled = true;
  }
}

modelDropdown.addEventListener('change', function() {
  updateSearchBtnState();
});

ffSearch.addEventListener('click', async function () {
  if (fwlocale === 'en') {
    $('#sbv-search-btn').text('searching...');
  } else if (fwlocale === 'fr') {
    $('#sbv-search-btn').text('Recherche...');
  }
  const selectedModel = modelDropdown.value;
  if (selectedModel === 'Select Model' || selectedModel === 'Sélectionnez le modèle') return;
  if (fwlocale === 'en') {
    $('#products-modal-Label').text(`Products for ${yearDropdown.value} ${makeDropdown.value} ${selectedModel}`);
  } else if (fwlocale === 'fr') {
    $('#products-modal-Label').text(`Produits pour ${yearDropdown.value} ${makeDropdown.value} ${selectedModel}`);
  }
  const data = await fetchData(makeDropdown.value, yearDropdown.value, selectedModel);
  allData = data;
  console.log(allData);
  const selectedProducts = selectProducts(data);
  const pmhasMultiple = selectedProducts.length >= 2;
  const collsData = await getAllColls();

  console.log(collsData);
  console.log(buynowclick);
  let sortFn;
  if (buynowclick === "gid://shopify/Collection/277754970249") {
    sortFn = (a, b) => a.CollectionOrder - b.CollectionOrder;
  } else if (buynowclick === "gid://shopify/Collection/277759787145") {
    sortFn = (a, b) => {
      const mid = Math.floor(selectedProducts.length / 2);
      const midValue = selectedProducts[mid].CollectionOrder;
      return Math.abs(a.CollectionOrder - midValue) - Math.abs(b.CollectionOrder - midValue);
    };
  } else if (buynowclick === "gid://shopify/Collection/277929885833") {
    sortFn = (a, b) => b.CollectionOrder - a.CollectionOrder;
  }
  
  const modalContent = $("#products-modal #products-modal-content");
  modalContent.empty();

  if (buynowclick === 'fwf') {
    $('#products-modal-content').toggleClass('sm:grid-cols-2', pmhasMultiple);
    selectedProducts.sort((a, b) => a.CollectionOrder - b.CollectionOrder);
    selectedProducts.forEach(vehicle => {
      modalContent.append(createProductAnchor(vehicle));
    });
  } else if (collsData.some(item => item.collectionID === buynowclick) && selectedProducts.length > 1) {
    $('#products-modal-content').removeClass('sm:grid-cols-2');
    const hasExpected = selectedProducts.some(vehicle => vehicle.CollectionID === buynowclick);
    
    if (!hasExpected) {
      if (fwlocale === 'en') {
        modalContent.append('<span class="text-center text-lg font-medium">Sorry, this product is currently unavailable. Please contact us for availability.</span>');
      } else if (fwlocale === 'fr') {
        modalContent.append('<span class="text-center text-lg font-medium">Désolé, ce produit n’est pas disponible pour le moment. Veuillez nous contacter pour connaître sa disponibilité.</span>');
      }
      addRelatedProductsLabel();
    }
    
    selectedProducts.sort(sortFn);
    selectedProducts.forEach((vehicle, index) => {
      modalContent.append(createProductAnchor(vehicle));
      if (index === 0 && hasExpected) {
        addRelatedProductsLabel();
      }
    });
  } else if (buynowclick !== 'fwf' && selectedProducts.length === 1) {
    $('#products-modal-content').removeClass('sm:grid-cols-2');
    const product = selectedProducts[0];
    
    if (product.CollectionID === buynowclick) {
      modalContent.append(createProductAnchor(product));
    } else {
      if (fwlocale === 'en') {
        modalContent.append('<span class="text-center text-lg font-medium">Sorry, this product is currently unavailable. Please contact us for availability.</span>');
      } else if (fwlocale === 'fr') {
        modalContent.append('<span class="text-center text-lg font-medium">Désolé, ce produit n’est pas disponible pour le moment. Veuillez nous contacter pour connaître sa disponibilité.</span>');
      }
      addRelatedProductsLabel();
      modalContent.append(createProductAnchor(product));
    }
  }
  const pmDialog = new A11yDialog(document.getElementById('products-modal'));
  pmDialog.show();
  if (fwlocale === 'en') {
    $('#sbv-search-btn').text('SEARCH');
  } else if (fwlocale === 'fr') {
    $('#sbv-search-btn').text('RECHERCHER');
  }
});

  function selectProducts(data) {
    const collectionMap = new Map();
    data.forEach(vehicle => {
      const collection = vehicle.CollectionID;
      const sortOrder = parseInt(vehicle.SortOrder, 10);
      const id = vehicle.ID;
      const collectionOrder = parseInt(vehicle.CollectionOrder, 10);
      const currentMin = collectionMap.get(collection);
      if (currentMin) {
        if (sortOrder < currentMin.sortOrder) {
          collectionMap.set(collection, { ...vehicle, sortOrder, collectionOrder });
        } else if (sortOrder === currentMin.sortOrder) {
          if (id !== currentMin.ID) {
            if (id < currentMin.ID) {
              collectionMap.set(collection, { ...vehicle, sortOrder, collectionOrder });
            }
          } else {
            if (Math.random() < 0.5) {
              collectionMap.set(collection, { ...vehicle, sortOrder, collectionOrder });
            }
          }
        }
      } else {
        collectionMap.set(collection, { ...vehicle, sortOrder, collectionOrder });
      }
    });

    const result = Array.from(collectionMap.values()).sort((a, b) => a.CollectionOrder - b.CollectionOrder);
    return result;
  }

  const cleanTranslatedArrayString = (str) => {
    if (typeof str !== 'string') return str;
    return str
      .replace(/\.\s*$/, '')
      .replace(/^\s+|\s+$/g, '');
  };

  function passOpts(vehicle, selectedYear) {
    let findYinQS = new URLSearchParams(window.location.search);
    var QSoptions = findYinQS.get("fwoptions");
    var qs_opt_data;
    if(QSoptions){
      try {
        const decoded = atobUtf8(decodeURIComponent(QSoptions)); 
        qs_opt_data = JSON.parse(decoded);
        //qs_opt_data = JSON.parse(atob(QSoptions));
      } catch (e) {
          console.log(e);
      }
      if (yearDropdown.value !== 'Select Year' && yearDropdown.value !== 'Sélectionnez l’année') {
          var options = {
            collectionID:vehicle.CollectionID,
            make:vehicle.Make,
            year:yearDropdown.value,
            model:vehicle.Model.trim(),
            opt:vehicle.Option ? vehicle.Option.trim() : 'undefined',
            fitnote:vehicle.FitNote ? vehicle.FitNote : 'undefined',
            frOpt:vehicle.language.fr.Option ? vehicle.language.fr.Option.trim() : 'undefined',
            frFitnote:vehicle.language.fr.FitNote ? cleanTranslatedArrayString(vehicle.language.fr.FitNote) : 'undefined',
            frModel:vehicle.language.fr.Model ? vehicle.language.fr.Model : 'undefined'
          };
      } else {
          var options = {
            collectionID:vehicle.CollectionID,
            make:vehicle.Make,
            year:qs_opt_data.year,
            model:vehicle.Model.trim(),
            opt:vehicle.Option ? vehicle.Option.trim() : 'undefined',
            fitnote:vehicle.FitNote ? vehicle.FitNote : 'undefined',
            frOpt:vehicle.language.fr.Option ? vehicle.language.fr.Option.trim() : 'undefined',
            frFitnote:vehicle.language.fr.FitNote ? cleanTranslatedArrayString(vehicle.language.fr.FitNote) : 'undefined',
            frModel:vehicle.language.fr.Model ? vehicle.language.fr.Model : 'undefined'
          };
        }
    } else {
        var options = {
          collectionID:vehicle.CollectionID,
          make:vehicle.Make,
          year:selectedYear,
          model:vehicle.Model.trim(),
          opt:vehicle.Option ? vehicle.Option.trim() : 'undefined',
          fitnote:vehicle.FitNote ? vehicle.FitNote : 'undefined',
          frOpt:vehicle.language.fr.Option ? vehicle.language.fr.Option.trim() : 'undefined',
          frFitnote:vehicle.language.fr.FitNote ? cleanTranslatedArrayString(vehicle.language.fr.FitNote) : 'undefined',
          frModel:vehicle.language.fr.Model ? vehicle.language.fr.Model : 'undefined'
        };
    }
    return options; 
  }

  function btoaUtf8(str) {
     return btoa(unescape(encodeURIComponent(str)));
  }

  function atobUtf8(b64) {
    return decodeURIComponent(escape(atob(b64)));
  }

  function openSetsModal(items, opt) {
    console.log('openSetsModal: ', items, opt);
    $("#sets-modal #sets-modal-content").empty();
    const smhasMultiple = items.length >= 2;
    $('#sets-modal-content').toggleClass('sm:grid-cols-2', smhasMultiple);
    let rp = [];
    items.sort((a, b) => a.SortOrder - b.SortOrder);
    items.forEach(function(vehicle) {
      if (fwlocale === 'en') {
        if (opt === undefined || vehicle.Option == opt && !rp.includes(vehicle.ID)) {
          rp.push(vehicle.ID);
          var a = document.createElement('a');
          var text = document.createElement('p');
          var price = document.createElement('span');
          const img = new Image();
          img.src = vehicle.PreviewImage;
          img.className="max-w-full max-h-full object-contain rounded-xl";
          img.alt = vehicle.CollectionName;
          const imgContainer = document.createElement('div');
          imgContainer.className = 'w-64 h-64 flex items-center justify-center overflow-hidden';
          imgContainer.appendChild(img);
          text.className = "max-w-64 text-lg mt-2.5 font-['Bebas_Neue']";
          text.textContent = vehicle.ProductTitle.split(' for')[0].trim();
          price.textContent = vehicle.Price;
          a.className = 'flex flex-col justify-between items-center text-center';
          // a.href = fullDomain + '/products/' + vehicle.ProductPage + '?fwoptions=' + btoa(JSON.stringify(passOpts(vehicle, yearDropdown.value)));
          a.href = fullDomain + '/products/' + vehicle.ProductPage +
         '?fwoptions=' + encodeURIComponent(
             btoaUtf8(JSON.stringify(passOpts(vehicle, yearDropdown.value)))
         );
          a.appendChild(imgContainer);
          a.append(text);
          if (fullDomain === "https://findway.ca") {
            a.append(price);
          }
          $("#sets-modal #sets-modal-content").append(a);
        }
      } else if (fwlocale === 'fr') {
        if (opt === undefined || vehicle.language.fr.Option == opt && !rp.includes(vehicle.ID)) {
          rp.push(vehicle.ID);
          var a = document.createElement('a');
          var text = document.createElement('p');
          var price = document.createElement('span');
          const img = new Image();
          img.src = vehicle.PreviewImage;
          img.className="max-w-full max-h-full object-contain rounded-xl";
          img.alt = vehicle.language.fr.CollectionName;
          const imgContainer = document.createElement('div');
          imgContainer.className = 'w-64 h-64 flex items-center justify-center overflow-hidden';
          imgContainer.appendChild(img);
          text.className = "max-w-64 text-lg mt-2.5 font-['Bebas_Neue']";
          text.textContent = vehicle.language.fr.ProductTitle.split(' pour')[0].trim();
          price.textContent = vehicle.Price;
          a.className = 'flex flex-col justify-between items-center text-center';
          // a.href = fullDomain + '/fr/products/' + vehicle.ProductPage + '?fwoptions=' + btoa(JSON.stringify(passOpts(vehicle, yearDropdown.value)));
          a.href = fullDomain + '/fr/products/' + vehicle.ProductPage +
         '?fwoptions=' + encodeURIComponent(
             btoaUtf8(JSON.stringify(passOpts(vehicle, yearDropdown.value)))
         );
          a.appendChild(imgContainer);
          a.append(text);
          if (fullDomain === "https://findway.ca") {
            a.append(price);
          }
          $("#sets-modal #sets-modal-content").append(a);
        }
      }
    });
    const smDialog = new A11yDialog(document.getElementById('sets-modal'));
    smDialog.show();
  }


  function generateOptionsDropdown(options) {
    const sortedOptions = options.sort((a, b) => a.Option.localeCompare(b.Option));
    const langSortedOptions = options.sort((a, b) => a.language.fr.Option.localeCompare(b.language.fr.Option));
    $('#opts-modal #opts-modal-content').removeClass('grid grid-cols-2 gap-8');
    if (fwlocale === 'en') {
      return `<select class="text-ellipsis whitespace-nowrap pl-2.5" id="opts-select" aria-label="Select Vehicle Option"><option value="">Select Option</option>${sortedOptions
      .map((opt) => `<option value="${opt.Option}">${opt.Option}</option>`).join("")}</select>`;
    } else if (fwlocale === 'fr') {
      return `<select class="text-ellipsis whitespace-nowrap pl-2.5" id="opts-select" aria-label="Sélectionnez la configuration du véhicule"><option value="">Sélectionnez une option</option>${langSortedOptions
      .map((opt) => `<option value="${opt.language.fr.Option}">${opt.language.fr.Option}</option>`).join("")}</select>`;
    }
  }

  function generateImageOptions(options) {
    const omhasMultiple = options.length >= 2;
    $('#opts-modal-content').toggleClass('sm:grid-cols-2', omhasMultiple);
    if (fwlocale === 'en') {
      return options.sort((a, b) => a.Option.localeCompare(b.Option)).map((opt) => 
      `<div class="opts_img_modal flex flex-col justify-center text-center items-center cursor-pointer" tabindex="0" aria-label="Select option ${opt.Option}" data-opt="${opt.Option}">
        <img class="w-64 h-auto max-h-64 rounded-xl" src="${opt.OptionImage}" alt="${opt.Option}" />
        <p class="max-w-64 text-base font-sans font-bold mt-2.5">${opt.Option}</p>
       </div>`).join("");
    } else if (fwlocale === 'fr') {
      return options.sort((a, b) => a.language.fr.Option.localeCompare(b.language.fr.Option)).map((opt) => 
      `<div class="opts_img_modal flex flex-col justify-center text-center items-center cursor-pointer" tabindex="0" aria-label="Sélectionnez une option ${opt.language.fr.Option}" data-opt="${opt.language.fr.Option}">
        <img class="w-64 h-auto max-h-64 rounded-xl" src="${opt.OptionImage}" alt="${opt.language.fr.Option}" />
        <p class="max-w-64 text-base font-sans font-bold mt-2.5">${opt.language.fr.Option}</p>
       </div>`).join("");
    }
  }

  function setupOptionSelectionHandlers(relatedProducts, options, optionCount, optionToProductPage) {
    const $optsModalContent = $("#opts-modal #opts-modal-content");
    const $optsSelect = $("#opts-select");
  
    $optsModalContent
      .off("click.findwayOpts", ".opts_img_modal")
      .on("click.findwayOpts", ".opts_img_modal", function () {
        const selectedOption = $(this).data("opt");
        handleOptionSelection(relatedProducts, options, selectedOption, optionCount, optionToProductPage);
      });
  
    $optsModalContent
      .off("keydown.findwayOpts", ".opts_img_modal")
      .on("keydown.findwayOpts", ".opts_img_modal", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          $(this).trigger("click");
        }
      });
  
    $optsSelect
      .off("change.findwayOpts")
      .on("change.findwayOpts", function () {
        handleOptionSelection(relatedProducts, options, this.value, optionCount, optionToProductPage);
      });
  
    $optsSelect
      .off("keydown.findwayOpts")
      .on("keydown.findwayOpts", function (e) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") e.preventDefault();
      });
  }

  // function setupOptionSelectionHandlers(relatedProducts, options, optionCount, optionToProductPage) {
  //   $("#opts-modal #opts-modal-content").on("click", ".opts_img_modal", function () {
  //     const selectedOption = $(this).data("opt");
  //     handleOptionSelection(relatedProducts, options, selectedOption, optionCount, optionToProductPage);
  //   });

  //   $("#opts-modal #opts-modal-content").on("keydown", ".opts_img_modal", function (e) {
  //     if (e.key === "Enter") {
  //       e.preventDefault();
  //       $(this).trigger("click");
  //     }
  //   });

  //   $("#opts-select").on("change", function () {
  //     const selectedOption = this.value;
  //     handleOptionSelection(relatedProducts, options, selectedOption, optionCount, optionToProductPage);
  //   });
  //   $("#opts-select").on("keydown", function(e) {
  //     if (e.key === "ArrowDown" || e.key === "ArrowUp") {
  //       e.preventDefault();
  //     }
  //   });
  // }

  function handleOptionSelection(relatedProducts, options, selectedOption, optionCount, optionToProductPage) {
    // console.log('handleOptionSelection: ', relatedProducts, options, selectedOption, optionCount, optionToProductPage);
    if (optionCount[selectedOption] == 1) {
      relatedProducts.forEach(function (vehicle) {
        if (fwlocale === 'en') {
          if (vehicle.Option == selectedOption) {
            // const singleOptionUrl = `/products/${optionToProductPage[selectedOption]}?fwoptions=` + btoa(JSON.stringify(passOpts(vehicle, yearDropdown.value)));
            const singleOptionUrl = `/products/${optionToProductPage[selectedOption]}?fwoptions=` + encodeURIComponent(btoaUtf8(JSON.stringify(passOpts(vehicle, yearDropdown.value))));
            window.location.href = singleOptionUrl;
          }
        } else if (fwlocale === 'fr') {
          if (vehicle.language.fr.Option == selectedOption) {
            const singleOptionUrl = `/fr/products/${optionToProductPage[selectedOption]}?fwoptions=` + encodeURIComponent(btoaUtf8(JSON.stringify(passOpts(vehicle, yearDropdown.value))));
            window.location.href = singleOptionUrl;
          }
        }
      });
    } else {
      openSetsModal(relatedProducts, selectedOption);
    }
  }

  // function processRelatedProducts(relatedProducts) {
  //     const seenOptions = new Set();
  //     const optionCount = {};
  //     const optionToProductPage = {};
  //     const options = relatedProducts.filter((vehicle) => {
  //       if (!seenOptions.has(vehicle.Option)) {
  //         seenOptions.add(vehicle.Option);
  //         optionCount[vehicle.Option] = 1;
  //         optionToProductPage[vehicle.Option] = vehicle.ProductPage;
  //         return true;
  //       }
  //       optionCount[vehicle.Option]++;
  //       return false;
  //     });
  //     return { options, optionCount, optionToProductPage };
  // }

function processRelatedProducts(relatedProducts) {
  const optionPath = fwlocale === 'fr' ? 'language.fr.Option' : 'Option';
  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((current, key) => current?.[key], obj);
  };

  const seenOptions = new Set();
  const optionCount = {};
  const optionToProductPage = {};

  const options = relatedProducts.filter((vehicle) => {
    const optionValue = getNestedValue(vehicle, optionPath);
    
    if (optionValue == null) return false;

    if (!seenOptions.has(optionValue)) {
      seenOptions.add(optionValue);
      optionCount[optionValue] = 1;
      optionToProductPage[optionValue] = vehicle.ProductPage;
      return true;
    }
    optionCount[optionValue]++;
    return false;
  });
  // console.log(options, optionToProductPage);
  return { 
    options, 
    optionCount, 
    optionToProductPage 
  };
}

  function processOpts(relatedProducts) {
    const { options, optionCount, optionToProductPage } = processRelatedProducts(relatedProducts);
    $("#opts-modal #opts-modal-content").empty();
    const modalContent = relatedProducts[0].OptionImage === "undefined" ? generateOptionsDropdown(options) : generateImageOptions(options);
    $("#opts-modal #opts-modal-content").append(modalContent);
    const optmDialog = new A11yDialog(document.getElementById('opts-modal'));
    optmDialog.show();
    setupOptionSelectionHandlers(relatedProducts, options, optionCount, optionToProductPage);
  }


  function getOptsData(id) {
    var relatedProducts = allData.filter(product => product.CollectionID === id);
    if (fwlocale === 'en') {
      if (relatedProducts.length == 1 && relatedProducts[0].Option == "undefined") {
        //window.location.href = '/products/' + relatedProducts[0].ProductPage + '?fwoptions=' +  btoa(JSON.stringify(passOpts(relatedProducts[0], yearDropdown.value)));
        window.location.href = '/products/' + relatedProducts[0].ProductPage + '?fwoptions=' + encodeURIComponent(btoaUtf8(JSON.stringify(passOpts(relatedProducts[0], yearDropdown.value))));
        
      } else if (relatedProducts.length == 1 && relatedProducts[0].Option !== "undefined") {
        processOpts(relatedProducts);
      } else {
        if (relatedProducts[0].Option == "undefined") {
          openSetsModal(relatedProducts);
        } else {
          processOpts(relatedProducts);
        }
      }
    } else if (fwlocale === 'fr') {
      if (relatedProducts.length == 1 && relatedProducts[0].language.fr.Option == "undefined") {
        window.location.href = '/fr/products/' + relatedProducts[0].ProductPage + '?fwoptions=' + encodeURIComponent(btoaUtf8(JSON.stringify(passOpts(relatedProducts[0], yearDropdown.value))));
      } else if (relatedProducts.length == 1 && relatedProducts[0].language.fr.Option !== "undefined") {
        processOpts(relatedProducts);
      } else {
        if (relatedProducts[0].language.fr.Option == "undefined") {
          openSetsModal(relatedProducts);
        } else {
          processOpts(relatedProducts);
        }
      }
    }
  }

  async function changeButtonClick(coID, make, year, model) {
    const data = await fetchData(make, year, model);
    var relatedProducts = data.filter(product => product.CollectionID === coID);
    processOpts(relatedProducts);
  }

async function backToresults(make, year, model) {
  const selectedModel = modelDropdown.value;
  if (fwlocale === 'en') {
    $('#products-modal-Label').text(`Products for ${year} ${make} ${model}`);
  } else if (fwlocale === 'fr') {
    $('#products-modal-Label').text(`Produits pour ${year} ${make} ${model}`);
  }

  const data = await fetchData(make, year, model);
  allData = data;
  const selectedProducts = selectProducts(data);
  const pmhasMultiple = selectedProducts.length >= 2;
  const collsData = await getAllColls();
  
  const modalContent = $("#products-modal #products-modal-content");
  modalContent.empty();

  $('#products-modal-content').toggleClass('sm:grid-cols-2', pmhasMultiple);
  selectedProducts.sort((a, b) => a.CollectionOrder - b.CollectionOrder);
  selectedProducts.forEach(vehicle => {
    modalContent.append(createProductAnchor(vehicle));
  });
  const pmDialog = new A11yDialog(document.getElementById('products-modal'));
  pmDialog.show();
}